<template>
  <div class="resetPassword xi">
    <nh-com></nh-com>
    <div class="startBox" >
      <div class="startBoxleft"  style="margin-top:50px">
        <img src="../../assets/img/queImg/pctop.png" style="width: 800px;height: 100px;" alt="" srcset="">
        <div style="padding: 20px 30px ;background: #FFFFFF;border-radius: 40px;">
        <div style="display: flex;align-items: center;justify-content: space-between;">
          <div style="display: flex;align-items: center;width: 200px;background: #FFFFFF;border: 1px solid #FF613D;border-radius: 6px;">
            <div  :class="tabIndex == 0 ? 'tabBoxChecked' : 'tabBox' " @click="goTabIndex(0)">诊断结果</div>
            <div :class="tabIndex == 1 ? 'tabBoxChecked' : 'tabBox' " @click="goTabIndex(1)">诊断过程</div>
          </div>
          <span  @click="chooseAnswer" style='cursor: pointer;' ><i class="el-icon-delete" style="color: #FF7B5A;font-size: 16px;margin-right: 5px;"></i>删除</span>
        </div>
          <!-- 结果 -->
              <div class="resultMessage"  v-if="tabIndex == 0">
                <div style="min-height: 550px;max-height: 550px;overflow-y: auto;">
                    <div class="endbox">
                      <div class="flexlr" style="align-items: center; background: #FFE9D4;border-radius: 23px;padding: 14px 30px;">
                        <div style="font-size: 16px; font-weight: bold; display: flex; align-items: center">
                          <div class="ring"></div>
                          <div style="margin-left: 5px">{{ resultList.userName }}</div>
                          <div class="" style="margin-left: 10px">
                            {{ resultList.gender ?  "女":  "男"}}
                          </div>
                          <div class="" style="margin-left: 10px">
                            {{ resultList.ageName }}
                          </div>
                          <div class="" style="margin-left: 10px">
                            {{ resultList.userPhone ? resultList.userPhone.substr(0, 3) + "****" + resultList.userPhone.substr(7) : "" }}
                          </div>
                        </div>
                        <div class="" style="text-align: right; font-size: 12px; color: #999999">
                          {{ resultList.diagnosisTime }}
                        </div>
                      </div>
                      <div style="padding: 20px 30px;padding-bottom: 15px;">
                        <div class="" style="font-size: 16px; color: #666666;">
                          基础病：
                          <span>{{ resultList.answerDiseaseName?resultList.answerDiseaseName:'暂未填写' }}</span>
                        </div>
                        <div class="" style="padding-top: 4px;color: #F15C1A;font-size: 16px;cursor: pointer;">
                          您选择的主症是：
                          <span  @click="getSelfDiagnosisPrimarySymptomDetailList(resultList.primarySymptomId)" style="margin-right: 5px;" >{{ resultList.primarySymptomName }}</span><i class="el-icon-warning-outline"></i>
                        </div>
                        <div class="" style="font-size: 16px; padding-top: 10px;">
                          <p style="color: #DF7D1F">您的症状清单：</p>
                          <span style="color: #DF7D1F;" v-for="(itemsym, indexsym) in resultList.symptoms" :key="indexsym"> {{ "【" + itemsym + "】" }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="endbox1" v-for="(item, index) in resultList.recordResults" :key="index">
                      <!-- <div v-if="item.matchingRate > 60 || item.matchingRate == 60" @click="godetail(item)">
                        <div class="boxtag1">{{ item.matchingRate }}%匹配度</div>
                        <div class="flexlr" style="align-items: center; margin-top: 15px">
                          <div class="" style="font-size: 16px; font-weight: bold; display: flex; align-items: center">
                            <div class="ring1"></div>
                            <div class="" style="margin-left: 10px">
                              {{ item.syndromeName }}
                            </div>
                          </div>
                        </div>
                        <div class="flexlr" style="padding: 14px 0; align-items: center">
                          <div class="" style="font-size: 15px; color: #666666; width: 85%">
                            <div v-if="item.tongueSymptoms || item.pulseSymptoms || item.symptoms">
                              <p>主要症状：</p>
                              <span :class="itemq.checked ? 'newChecked' : ''" v-for="(itemq, indexq) in item.newsyndromeSymptoms" :key="indexq">
                                {{ "【" + itemq.name + "】" }}
                              </span>
                            </div>
                          </div>
                          <div style="width: 24px; height: 24px">
                            <img src="@/assets/img/zdrugConsult/right1.png" alt="" srcset="" style="width: 100%; height: 100%" />
                          </div>
                        </div>
                      </div> -->
                      <div  @click="godetail(item)">
                        <div class="flexlr" style="align-items: center;background: #FFE9D4;border-radius: 23px;padding: 14px 30px;">
                          <div class="" style="font-size: 18px; font-weight: bold;color: #333333; display: flex; align-items: center">
                            <div class="ring"></div>
                            <div class="" style="margin-left: 10px">
                              {{ item.syndromeName }}
                            </div>
                          </div>
                          <div style="font-weight: bold;font-size: 18px;color: #F15C1A;display: flex;align-items: center;">
                            {{ item.matchingRate }}%匹配度
                            <img src="../../assets/img/queImg/right.png" alt="" srcset="" style="width: 18px; height: 18px;margin-left: 10px;" />
                          </div>
                        </div>
                        <!-- v-if="item.matchingRate > 60 || item.matchingRate == 60" -->
                        <div class="flexlr" style="padding: 20px 30px; align-items: center">
                          <div class="" style="font-size: 18px; color: #666666;">
                            <div v-if="item.tongueSymptoms || item.pulseSymptoms || item.symptoms">
                              <p>主要症状：</p>
                              <span style="cursor: pointer;" :class="itemq.checked ? 'newChecked' : ''" v-for="(itemq, indexq) in item.newsyndromeSymptoms" :key="indexq">
                                {{ "【" + itemq.name + "】" }}
                              </span>
                            </div>
                          </div>
                
                        </div>
                      </div>
                      <!-- <div v-if="item.matchingRate < 60 && item.matchingRate >= 30" @click="godetail(item)">
                        <div class="boxtag2">{{ item.matchingRate }}%匹配度</div>
                        <div class="flexlr" style="align-items: center; margin-top: 15px">
                          <div class="" style="font-size: 16px; font-weight: bold; display: flex; align-items: center">
                            <div class="ring2"></div>
                            <div class="" style="margin-left: 10px">
                              {{ item.syndromeName }}
                            </div>
                          </div>
                        </div>
                        <div class="flexlr" style="padding: 14px 0; align-items: center">
                          <div class="" style="font-size: 15px; color: #666666; width: 85%">
                            <div v-if="item.tongueSymptoms || item.pulseSymptoms || item.symptoms">
                              <p>主要症状：</p>
                              <span :class="itemq.checked ? 'newChecked' : ''" v-for="(itemq, indexq) in item.newsyndromeSymptoms" :key="indexq">
                                {{ "【" + itemq.name + "】" }}
                              </span>
                            </div>
                          </div>
                          <div style="width: 24px; height: 24px">
                            <img src="@/assets/img/zdrugConsult/right2.png" alt="" srcset="" style="width: 100%; height: 100%" />
                          </div>
                        </div>
                      </div> -->
                      <!-- <div v-if="item.matchingRate < 30" @click="godetail(item)">
                        <div class="boxtag3">{{ item.matchingRate }}%匹配度</div>
                        <div class="flexlr" style="align-items: center; margin-top: 15px">
                          <div class="" style="font-size: 16px; font-weight: bold; display: flex; align-items: center">
                            <div class="ring3"></div>
                            <div class="" style="margin-left: 10px">
                              {{ item.syndromeName }}
                            </div>
                          </div>
                        </div>
                        <div class="flexlr" style="padding: 14px 0; align-items: center">
                          <div style="font-size: 15px; color: #666666; width: 85%">
                            <div v-if="item.tongueSymptoms || item.pulseSymptoms || item.symptoms">
                              <p>主要症状：</p>
                              <span :class="itemq.checked ? 'newChecked' : ''" v-for="(itemq, indexq) in item.newsyndromeSymptoms" :key="indexq">
                                {{ "【" + itemq.name + "】" }}
                              </span>
                            </div>
                          </div>
                          <div style="width: 24px; height: 24px">
                            <img src="@/assets/img/zdrugConsult/right3.png" alt="" srcset="" style="width: 100%; height: 100%" />
                          </div>
                        </div>
                      </div> -->
                    </div>
                  </div>
                </div>
                    <div style="min-height: 550px;max-height: 550px;overflow-y: auto;" v-if="tabIndex == 1">
      <div class="endbox" style="background: #F5F5F5;">
        <div class="" v-for="(queitem, indexque) in infoList" :key="indexque">
          <div style="margin-top: 20px; padding: 20px 30px;">
            <div class="leftbox">
              <div class="" style="width: 45px; height: 45px">
                <img src="@/assets/img/zdrugConsult/zdrugren.png" mode="" style="width: 100%; height: 100%" />
              </div>
              <div class="leftMessage">
                {{ queitem.questionName }}
                <div v-for="(item, index) in queitem.dataInfo" :key="index">
                  <div class="" v-if="item.questionFileUrl" style="display: flex; padding-top: 5px; flex-wrap: wrap">
                    <!-- <div class="" v-for="(itemimg, indeximg) in item.questionFileUrl" :key="indeximg">
                      <img :src="http + itemimg" style="width: 60px; height: 60px; border-radius: 4px; margin-left: 3px" />
                    </div> -->
                    <img :src="http + item.questionFileUrl[0]" style="width: 60px; height: 60px; border-radius: 4px; margin-left: 3px" />
                  </div>
                </div>
              </div>
            </div>
            <div class="rightbox">
              <div class="rightMessage">
                <div class="" v-for="(item, index) in queitem.dataInfo" :key="index">
                  {{ item.questionOptionName }}
                  <div v-if="item.questionOptionFileUrl" style="display: flex; padding-top: 5px; flex-wrap: wrap">
                    <div class="" v-for="(itemimgins, indeximgins) in item.questionOptionFileUrl" :key="indeximgins">
                      <img :src="http + itemimgins" style="width: 60px; height: 60px; border-radius: 4px; margin-left: 3px" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

          </div>
        </div>
        <!-- <div class="startBoxleftBot">
          <div class="startBoxleftBotn">
            <el-button round type="danger" @click="chooseAnswer">删除记录</el-button>
            <el-button round type="primary" @click="toPage">再次测试</el-button>
          </div>
        </div> -->
      </div>


        <!-- <div class="rightBottomBox">
                    <div class="flexlr" style="padding: 0 30px">
                        <div style="text-align: center;">
                            <div style="width:102px;height:102px ;">
                                <img src="../../assets/img/ampCode.jpg" alt="" srcset="" style="width:100%;height:100%">
                            </div>
                              <span>微信小程序</span>
                        </div>
                        <div style="text-align: center;">
                            <div style="width:102px;height:102px;">
                                <img src="../../assets/img/code_d3.png" alt="" srcset="" style="width:100%;height:100%">
                            </div>
                              <span>APP下载(安卓)</span>
                        </div>
                    </div>
                    <div class="rightBottom">
                        扫码收藏小程序或下载千越医助手APP 随时随地开启中医问诊，您身边的健康助手
                    </div>
                </div> -->
      </div>
              </div>
                      <!-- <el-dialog title="提示" :visible.sync="dialogVisibleDetail" width="60%">
          <div class="dialogTitle">
            {{ selfDiagnosisPrimarySymptomDetail.primarySymptomName }}
          </div>
          <div class="textdetail" v-if="selfDiagnosisPrimarySymptomDetail.symptomDescription">
            <div class="">
              <p v-html="selfDiagnosisPrimarySymptomDetail.description.replace(/\n/g, '</p> <p>')"></p>
            </div>
          </div>
        </el-dialog> -->
          <el-dialog title="详情" :visible.sync="dialogVisibleDetail" width="30%">
            <div class="dialogTitle">
              {{ selfDiagnosisPrimarySymptomDetail.primarySymptomName }}
            </div>
            <div class="textdetail" v-if="selfDiagnosisPrimarySymptomDetail.symptomDescription">
              <div class="" @click="handleRichClick">
                <p  v-html="richHtml"></p>
              </div>
            </div>
          </el-dialog>
          <el-dialog
            title="图片预览"
            :visible.sync="dialogVisible"
            width="30%"
            append-to-body
            center
          >
            <div style="text-align:center;">
              <img :src="previewImgSrc" style="max-width:100%;max-height:100%;" />
            </div>
          </el-dialog>
        <!-- <div class="startBoxleftBot">
          <div class="startBoxleftBotn">
            <el-button round type="danger" @click="chooseAnswer">删除记录</el-button>
            <el-button round type="primary" @click="toPage">再次测试</el-button>
          </div>
        </div> -->

    <ft-com></ft-com>
  </div>
</template>

<script>
import ftCom from "../../components/footerNew";
import nhCom from "../../components/header";
import { zdrugconsultationMain } from "../../components/zdrugconsultation/zdrugconsultation";
export default {
  components: {
    ftCom,
    nhCom,
  },
  data() {
    var zdrugconsultation = new zdrugconsultationMain(this.TokenClient, this.Services.Disease);
    return {
      zdrugconsultationMain: zdrugconsultation,
      resultList: {},
      http: "",
      infoList: [],
      dialogVisibleDetail: false,
      selfDiagnosisPrimarySymptomDetail: {},
      tabIndex:0,
      previewImgSrc:'',
      dialogVisible:false,
    };
  },
  mounted() {
    let id = this.$route.query.id;
    this.getUserSelfDiagnosisRecordResultList(id);
    this.http = this.Services.ossUpload;
  },
        computed: {
    richHtml() {
      const content = this.selfDiagnosisPrimarySymptomDetail.description;
      // 重点：后端返回已经是完整HTML（包含<p>、img），不再转换换行！
      return content;
    }
  },
  methods: {
              handleRichClick(e) {
      const target = e.target;
      if (target.tagName.toUpperCase() === "IMG") {
        this.previewImgSrc = target.src;
        this.dialogVisible = true;
      }
    },
        goTabIndex(e){
      this.tabIndex = e
    },
    // 主症详情
    getSelfDiagnosisPrimarySymptomDetailList(e) {
      var _this = this;
      _this.zdrugconsultationMain.getSelfDiagnosisPrimarySymptomDetail(
        e,
        function (data) {
          _this.selfDiagnosisPrimarySymptomDetail = data.data;
          _this.dialogVisibleDetail = true;
        },
        function (error) {
          console.log(error);
        }
      );
    },
    godetail(e) {
      this.$router.push({
        path: "/zdrugconsultation/zdrugsynDetail",
        query: {
          id: e.syndromeId,
        },
      });
    },
    // 症状分类
    getUserSelfDiagnosisRecordResultList(e) {
      var _this = this;
      _this.zdrugconsultationMain.getUserSelfDiagnosisRecordResult(
        e,
        function (data) {
          if (data.data.age == 0) {
            data.data.ageName = "6岁以下";
          } else if (data.data.age == 7) {
            data.data.ageName = "7-12岁";
          } else if (data.data.age == 13) {
            data.data.ageName = "13-17岁";
          } else if (data.data.age == 18) {
            data.data.ageName = "18-45岁";
          } else if (data.data.age == 46) {
            data.data.ageName = "46-69岁";
          } else if (data.data.age == -1) {
            data.data.ageName = data.data.primarySymptomMinAge + "-" + data.data.primarySymptomMaxAge + "岁";
          } else {
            data.data.ageName = "69岁以上";
          }
          _this.resultList = data.data;
          _this.resultList.diagnosisTime = _this.resultList.diagnosisTime.slice(0, 10);
          let contantList = [];
          for (let i = 0; i < _this.resultList.recordResults.length; i++) {
            if (_this.resultList.recordResults[i].pulseSymptoms == null) {
              _this.resultList.recordResults[i].pulseSymptoms = [];
            } else if (_this.resultList.recordResults[i].symptoms == null) {
              _this.resultList.recordResults[i].symptoms = [];
            } else if (_this.resultList.recordResults[i].tongueSymptoms == null) {
              _this.resultList.recordResults[i].tongueSymptoms = [];
            } else {
              console.log("123");
            }
            contantList = _this.resultList.recordResults[i].pulseSymptoms.concat(_this.resultList.recordResults[i].symptoms.concat(_this.resultList.recordResults[i].tongueSymptoms));
            _this.resultList.recordResults[i].contantLists = contantList;
            let newsyndromeSymptoms1 = [];
            for (let k = 0; k < _this.resultList.recordResults[i].syndromeSymptoms.length; k++) {
              newsyndromeSymptoms1.push({
                name: _this.resultList.recordResults[i].syndromeSymptoms[k],
                checked: false,
              });
            }
            _this.resultList.recordResults[i].newsyndromeSymptoms = newsyndromeSymptoms1;
          }
          for (let m = 0; m < _this.resultList.recordResults.length; m++) {
            for (let n = 0; n < _this.resultList.recordResults[m].contantLists.length; n++) {
              for (let j = 0; j < _this.resultList.recordResults[m].newsyndromeSymptoms.length; j++) {
                if (_this.resultList.recordResults[m].newsyndromeSymptoms[j].name == _this.resultList.recordResults[m].contantLists[n]) {
                  _this.resultList.recordResults[m].newsyndromeSymptoms[j].checked = true;
                }
              }
            }
          }
          _this.zdrugconsultationMain.getUserSelfDiagnosisRecordInfo(
            e,
            function (data) {
              for (let i = 0; i < data.data.length; i++) {
                if (data.data[i].questionFileUrl) {
                  data.data[i].questionFileUrl = JSON.parse(data.data[i].questionFileUrl);
                }
                if (data.data[i].questionOptionFileUrl) {
                  data.data[i].questionOptionFileUrl = JSON.parse(data.data[i].questionOptionFileUrl);
                }
              }
              _this.infoList = _this.checkSameData(data.data);
              for (let j = 0; j < _this.infoList.length; j++) {
                if (_this.infoList[j].dataInfo.length > 1) {
                  _this.infoList[j].dataInfo = _this.infoList[j].dataInfo.reverse();
                }
              }
            },
            function (error) {
              console.log(error);
            }
          );
        },
        function (error) {
          console.log(error);
        }
      );
    },
    // 滚动到底部
    handleScrollBottom() {
      this.$nextTick(() => {
        let scrollElem = this.$refs.scrollDiv;
        scrollElem.scrollTo({ top: scrollElem.scrollHeight, behavior: "smooth" });
      });
    },
    toPage() {
      this.$router.push("/zdrugconsultation/zDrugStart");
    },
    chooseAnswer() {
      var _this = this;
      _this
        .$confirm("确定删除本次测试结果吗?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          // center: true,
        })
        .then(() => {
          _this.zdrugconsultationMain.getUserSelfDiagnosisRecordDelete(
            _this.$route.query.id,
            function (data) {
              _this.$message({
                type: "success",
                message: "删除成功!",
              });
              _this.$router.push("/personal/SelfTest");
            },
            function (error) {
              console.log(error);
              _this.$message({
                type: "warning",
                message: "删除失败!",
              });
            }
          );
        })
        .catch(() => {});
    },
    checkSameData(resData) {
      let tempArr = [];
      let Data = [];
      for (let i = 0; i < resData.length; i++) {
        if (tempArr.indexOf(resData[i].questionName) == -1) {
          Data.push({
            questionName: resData[i].questionName,
            dataInfo: [resData[i]],
            questionOptionName: resData[i].questionOptionName,
          });
          tempArr.push(resData[i].questionName);
        } else {
          for (let j = 0; j < Data.length; j++) {
            if (Data[j].questionName == resData[i].questionName) {
              Data[j].dataInfo.push(resData[i]);
              break;
            }
          }
        }
      }
      return Data;
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/footer.css";
::v-deep .el-dialog {
  width: 28% !important;
  margin-top: 20vh !important;
}

.dialogTitle {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  color: #F15C1A;
}

.banner-wrap {
  position: relative;
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

.leftbox {
  display: flex;
  align-items: center;
  
}

.leftMessage {
  max-width: 240px;
  margin-top: 15px;
  font-size: 18px;
  padding: 10px 20px;
  background: #FFFFFF;
  border-radius: 0px 8px 8px 8px;
  margin-left: 20px;
}

.rightbox {
  display: flex;
  justify-content: flex-end;
  text-align: right;
}

.rightMessage {
  max-width: 240px;
  margin-top: 15px;
  font-size: 18px;
  padding: 10px 20px;
  background-color: #ee9e51;
  border-radius: 8px 0px 8px 8px;
  color: #fff;
}

.startBox {
  background: linear-gradient(180deg, #FFEFDE 0%, #F5F5F5 50%);
  /* border-radius: 19px; */
  padding: 30px;
}

.startBoxleft {
  position: relative;
  width: 800px;
  height: 750px;
  background: #ffffff;
  border-radius: 40px;
  margin: auto;
  /* overflow-y: auto; */
}


::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  display: none;
}
::-webkit-scrollbar-thumb {
  background: #c2c2c2;
  border-radius: 3px;
}

.startBoxleftBot {
  /* overflow-x:scroll; */
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding-bottom: 15px;
  border-top: 1px solid #e6e6e6;
  position: relative;
}

.startBoxleftBotn {
  margin-top: 12px;
  text-align: right;
  margin-right: 30px;
}

.startBoxright {
  margin-left: 2%;
  width: 38%;
  height: 720px;
  padding: 30px;
  background: #ffffff;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  overflow-y: auto;
}

/*滚动条样式*/
.startBoxright::-webkit-scrollbar {
  width: 4px;
}

.startBoxright::-webkit-scrollbar-thumb {
  border-radius: 10px;
  /* box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
  background: #ccc;
}

.startBoxright::-webkit-scrollbar-track {
  /* box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
  border-radius: 10px;
  background: #ffffff;
}
.surebtn {
  background: linear-gradient(180deg, #ffb163, #ee9e51);
  font-size: 16px;
  color: #ffffff;
  padding: 17rpx 0;
  width: 100%;
  text-align: center;
}

.goodTagCheck {
  font-size: 18px;
  text-align: center;
  padding: 5px 32px;
  background-color: #ffe6cd;
  border-radius: 20px;
  margin-left: 10px;
  color: #df7d1f;
}

.goodTag {
  font-size: 18px;
  text-align: center;
  padding: 5px 32px;
  background-color: #f2f2f2;
  border-radius: 20px;
  margin-left: 10px;
}

/* 症状 */
.textdetail {
  padding: 15px;
  /* background-color: #f2f2f2; */
  border-radius: 12px;
  max-height: 400px;
  min-height: 200px;
  overflow-y: auto;
}

.viptable {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  overflow-x: scroll;
}

.viptableY {
  width: 100%;
  height: 150px;
  overflow: hidden;
  overflow-y: scroll;
}

.endbox {
  margin-top: 20px;
  background: #FFF8F1;
border-radius: 20px;

}

.endboxright {
  margin-top: 15px;
  padding: 10px 15px;
  background: #ffffff;
  box-shadow: 0px 6px 0px 0px #f3d6bc;
  border-radius: 10px;
  border: 1px solid #f3d6bc;
}

.ring {
  width: 8px;
height: 8px;
background: #FF6846;
border-radius: 50%;
}

.endbox1 {
  /* margin-top: 20px;
  padding: 15px;
  background: #ffffff;
  box-shadow: 0px 4px 8px 0px rgba(214, 214, 214, 0.3);
  border-radius: 10px;
  position: relative;
  border: 1px solid #ffe5cb; */
}

.ring1 {
  width: 6px;
  height: 6px;
  background: #df7d1f;
  border-radius: 50%;
}

.ring2 {
  width: 6px;
  height: 6px;
  background: #3bc8d9;
  border-radius: 50%;
}

.ring3 {
  width: 6px;
  height: 6px;
  background: #68caa9;
  border-radius: 50%;
}

/* .boxtag2 {
  position: absolute;
  top: 0;
  right: 0;
  padding: 7px;
  color: #ffffff;
  border-radius: 10px 0px 10px 0px;
  background-color: #3bc8d9;
  font-size: 24rpx;
} */

.boxtag3 {
  position: absolute;
  top: 0;
  right: 0;
  padding: 7px;
  color: #ffffff;
  border-radius: 10px 0px 10px 0px;
  background: #68caa9;
  font-size: 12px;
}

.boxtag1 {
  /* position: absolute;
  top: 0;
  right: 0;
  padding: 7px;
  color: #ffffff;
  border-radius: 10px 0px 10px 0px;
  background-color: #f6a11f;
  font-size: 12px; */
}

.flexlr {
  display: flex;
  justify-content: space-between;
}
.flexlf {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
}

.resultimg {
  width: 100%;
  height: 100px;
  background-size: cover;
  background-image: url("../../assets/img/zdrugConsult/rstban.png");
  background-color: #f6a11f;
}

.rightBottom {
  padding: 10px 25px;
  background: #f0f2f2;
  border-radius: 25px;
  font-size: 13px;
  color: #999999;
  text-align: center;
}

.rightBottomBox {
  border-top: 1px solid #e6e6e6;
  padding: 20px;
  position: absolute;
  top: 10px;
  left: 0;
  background: #fff;
}

.radioBox {
  margin: 10px 0;
  font-size: 18px;
}

.imgTag {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  margin-left: 10px;
  border-radius: 8px;
}

.imgTagCheck {
  background-color: #feaf62;
  /* opacity: 0.5; */
  padding: 5px;
}

.textCheck {
  color: #df7d1f;
}

.hide-tooltip {
  max-width: 400px;
  /* visibility: hidden; */
}

.newChecked {
  color: #df7d1f;
}
.tabBox {
  width: 50%;
  text-align: center;
  padding: 5px 0;
  font-size: 16px;
  color: #666666;
  border-radius: 6px;
  cursor: pointer;
}
.tabBoxChecked {
  width: 50%;
  text-align: center;
  padding: 5px 0;
  font-size: 16px;
  color: #F15C1A;
  background: #FFEFE0;
  border-radius: 6px;
  cursor: pointer;
}
</style>
<style>
.personal-center {
  display: none;
}
</style>
